<!-- 新手指引 -->
<template>
  <div class="help-document">
    <gat-head></gat-head>
    <div class="help-center clearfix">
      <!-- 左侧导航菜单 -->
      <div class="help-left">
        <h2 class="title">新手指引</h2>
        <el-tree
          :data="guideTypes"
          :props="defaultProps"
          node-key="id"
          default-expand-all
          :highlight-current="true"
          @node-click="handleNodeClick"
          ref="toolTree"
        >
        </el-tree>
      </div>
      <!-- 右侧主内容 -->
      <guide-document-page
        :currentGuide="currentGuide"
        :hashId="hashId"
      ></guide-document-page>
    </div>
  </div>
</template>

<script>
import GuideDocumentPage from './GuideDocumentPage.vue'
import trainingGuide from './data/trainingGuideTeacher.js'
import trainingGuideStudent from './data/trainingGuideStudent.js'
import imgClassify from './data/imgClassify.js'
import objectMark from './data/objectMark.js'
import textClassify from './data/textClassify.js'
import textMark from './data/textMark.js'
import audioClassify from './data/audioClassify.js'
import audioMark from './data/audioMark.js'
import blocklyEditor from './data/editor/blocklyEditor.js'
import aiTPythonEditor from './data/editor/aiTPythonEditor.js'
import { mapGetters } from 'vuex'

export default {
  name: 'help-document',
  components: {
    // AiIntroducePage,
    GuideDocumentPage,
    // NavMenu,
    // GatFooter,
  },

  data() {
    return {
      currentGuide: {},
      scrollTop: 0,
      navState: 'AiIntroduce',
      navStateName: '',
      hashId: '',
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      guideTypesList: [
        {
          id: 10,
          label: '编辑器',
          type: 'editor',
          children: [
            {
              id: 11,
              label: 'AI-T编辑器（积木模式）',
              type: 'blockly-editor',
            },
            {
              id: 12,
              label: 'AI-T编辑器（代码模式）',
              type: 'ai-t-python-editor',
            },
          ],
        },
        {
          id: 1,
          label: '实训中心（老师）',
          type: 'training-center-teacher',
        },
        {
          id: 9,
          label: '实训中心（学生）',
          type: 'training-center-student',
        },
        {
          id: 2,
          label: '模型训练',
          type: 'model-training',
          children: [
            { id: 3, label: '图像分类', type: 'img-classify' },
            { id: 4, label: '物体检测', type: 'object-mark' },
            { id: 5, label: '文本分类', type: 'text-classify' },
            { id: 6, label: '文本标注', type: 'text-mark' },
            { id: 7, label: '音频分类', type: 'audio-classify' },
            { id: 8, label: '音频标注', type: 'audio-mark' },
          ],
        },
      ],
      // blockList: [],
      toolList: [], // 接口返回模型列表
      // filterToolList: [], // 过滤返回模型列表
      guideId: '',
    }
  },
  // filters: {
  //   filterList(list) {
  //     let _this = this
  //     var arr = list.filter((item) => {
  //       if (_this.userRole != 2) {
  //         //非学生角色
  //         return item.type !== 'training-center-student'
  //       } else {
  //         //学生角色
  //         return item.type !== 'training-center-teacher'
  //       }
  //     })
  //     return arr
  //   },
  // },
  watch: {
    // currentGuide: {
    //   handler(val) {
    //     // console.log('val ', val)
    //   },
    //   // deep: true,
    //   // immediate: true,
    // },
  },
  computed: {
    guideTypes() {
      var arr = this.guideTypesList.filter((item) => {
        if (this.userRole != 2) {
          //非学生角色
          return item.type !== 'training-center-student'
        } else {
          //学生角色
          return item.type !== 'training-center-teacher'
        }
      })
      return arr
    },
    ...mapGetters(['userRole']),
  },
  mounted() {
    let navStateName = window.location.hash.split('#')[1] || 'training-center'
    this.guideId = this.navStateName = navStateName
    if (this.guideId == 'training-center') {
      if (this.userRole == 2) {
        //学生角色的实训中心
        this.guideId = 'training-center-student'
      } else {
        //老师角色的实训中心
        this.guideId = 'training-center-teacher'
      }
    }
    this.navState = this.guideId
    this.hashId = this.guideId
    this.navClick(this.guideId)
    this.setCheckedKeys(this.guideId, this.guideTypesList)
  },
  methods: {
    onHashId(val) {
      this.hashId = val
    },
    onNavState(val) {
      this.navClick(val)
    },
    navClick(val) {
      console.log('val', val)
      // let hash = window.location.hash
      // if (hash) {
      //   this.hashId = hash.split('#')[1]
      //   console.log('this.navState', val)
      // }

      switch (true) {
        case val === 'blockly-editor':
          this.currentGuide = blocklyEditor
          break
        case val === 'ai-t-python-editor':
          this.currentGuide = aiTPythonEditor
          break
        case val === 'training-center-teacher':
          this.currentGuide = trainingGuide
          break
        case val === 'training-center-student':
          this.currentGuide = trainingGuideStudent
          break
        case val === 'model-training':
          break
        case val === 'img-classify':
          this.currentGuide = imgClassify
          break
        case val === 'text-classify':
          this.currentGuide = textClassify
          break
        case val === 'text-mark':
          this.currentGuide = textMark
          break
        case val === 'object-mark':
          this.currentGuide = objectMark
          break
        case val === 'audio-classify':
          this.currentGuide = audioClassify
          break
        case val === 'audio-mark':
          this.currentGuide = audioMark
          break
        default:
          break
      }
    },
    setCheckedKeys(type, guideTypesList) {
      let node
      guideTypesList.forEach((nodeItem) => {
        if (nodeItem.type == type) {
          node = nodeItem
          return
        } else if (nodeItem.children && nodeItem.children.length > 0) {
          this.setCheckedKeys(type, nodeItem.children)
        }
      })
      if (node && 'id' in node) {
        this.$refs.toolTree.setCurrentNode(node)
      }
    },
    handleNodeClick(data) {
      this.navClick(data.type)
    },
  }, //methods end
}
</script>

<style lang="scss" scoped>
.help {
  &-document {
    background: #f2f5fc;
  }
  &-center {
    min-width: 1200px;
    width:76%;
    margin: 0 auto;
    padding-top: 120px;
    box-sizing: border-box;
  }
  &-left {
    position: fixed;
    // width: 20%;
    min-width: 220px;
    height: 85%;
    // height: 100%;
    margin-right: 10px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(51, 51, 51, 0.05);
    overflow-x: hidden;
    overflow-y: auto;

    .title {
      line-height: 60px;
      font-size: 16px;
      color: #333;
      text-align: center;
    }
    .item {
      border-left: 3px solid transparent;
      text-indent: 17px;
      font-size: 14px;
      color: #333;
      line-height: 40px;
      cursor: pointer;
      &:hover,
      &.active {
        border-left: 3px solid #4c88ff;
        background: #dfeaff;
      }
      a {
        font-size: 14px;
        color: #333;
      }
    }
  }
}
.help-document .gat-head {
  width: 100%;
  position: fixed !important;
  top: 0;
  z-index: 3;
  box-sizing: border-box;
}

.help-document {
  width: 100%;
  // height: 100%;
  ::v-deep .el-tree-node__content {
    height: 40px;
    border-left: 3px solid transparent;
    text-indent: 17px;
    font-size: 14px;
    color: #333;
    line-height: 40px;
    cursor: pointer;
    &:hover,
    &.active {
      // border-left: 3px solid #4c88ff;
      // background: #dfeaff;
      color: #4c88ff;
    }
  }
  ::v-deep .el-tree-node.is-current > .el-tree-node__content {
    background: #f0f4ff;
    border-left: 3px solid #4c88ff;
    color: #4c88ff;
    font-weight: bold;

    // border-left: 3px solid #4c88ff;
    // background: #dfeaff;
  }
  ::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
    width: 10px;
    height: 10px;
  }
  ::v-deep.el-tree-node__content {
    text-indent: 0;
  }
}

.clearfix:after {
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
  content: '';
}
</style>
